import React from 'react';
import './LogBook.css';

function LogBook({ onClose, log }) {
  return (
    <div className='dialogbackground' onClick={onClose}>
      <div className='logbookdialog'>
        <div className='logbookheader'>Log book</div>
        <div className='scrollarea'>
        {
          log.length === 0
          ? <div className='logentry empty'>Nothing in the log yet</div>
          : [...log].reverse().map((entry, i) => {
              switch (entry.type) {
                case "discovery":
                  return <div key={i} className='logentry discovery'>
                    <div className='logtype'>Discovery</div>
                    <div className='description'>
                      <div className='item'>{
                        typeof(entry.ancestor) === 'string'
                        ? <><img alt='' src={require(`./images/land.svg`).default}></img>{entry.ancestor}</>
                        : <><img alt='' src={require(`./images/${entry.ancestor.id}.svg`).default}></img>{entry.ancestor.name}</>
                      }
                      </div>
                      <div className='symbol'><div className='text'>&#8594;</div><div className='spacer'>&nbsp;</div></div>
                      <div className='item'><img alt='' src={require(`./images/${entry.descendant.id}.svg`).default}></img>{entry.descendant.name}</div>
                    </div>
                  </div>;
                case "hint":
                  return <div key={i} className={'logentry hint' + (entry.discovered ? ' discovered' : '')}>
                    <div className='logtype'>Hint{(entry.discovered ? ' (discovered)' : '')}</div>
                    <div className='description'>
                      {
                        entry.requirementAdvancements.map((advancement, j) => 
                          <React.Fragment key={j}>
                            { j !== 0 && <div className='symbol'><div className='text'>+</div><div className='spacer'>&nbsp;</div></div> }
                            <div className='item'><img alt='' src={require(`./images/${advancement.id}.svg`).default}></img>{advancement.name}</div>
                          </React.Fragment>
                        )
                      }
                    </div>
                  </div>;
                case "text":
                  return <div key={i} className='logentry text'>
                    <div className='logtype'>{entry.heading}</div>
                    <div className='description'>{entry.value}</div>
                  </div>;
              }
            })
        }
        </div>
      </div>
    </div>
  );
}

export default LogBook;
